import type { ButtonProps } from "antd";
import { Button } from "antd";
import type { FC } from "react";

export type IotButtonProps = ButtonProps;

export const IotButtonBase: FC<IotButtonProps> = (props) => (
    <Button {...props} />
);
